import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import { CombinedJobScheduleInfo, EditSchedulerJobFormValues } from "../schedulerTypes"
import { EditSchedulerJobFromContent } from "./EditSchedulerJobFromContent"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import * as yup from "yup"
import { DateTime } from "luxon"

type EditSchedulerJobFormProps = Readonly<{
    initialValues?: CombinedJobScheduleInfo | null
    onSubmit: (formData: EditSchedulerJobFormValues) => void
}>
type FormikRef = Ref<FormikProps<EditSchedulerJobFormValues>>

export const EditSchedulerJobForm = forwardRef(
    ({ initialValues, onSubmit }: EditSchedulerJobFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues: CombinedJobScheduleInfo = {
            status: false,
            startTime: DateTime.now(),
            cronExpression: "",
            id: 0,
            lastRun: "",
            name: "",
        }

        const validationSchema = yup.object({
            startTime: yup.string().required(l10n.getString("required-field")),
            cronExpression: yup.string().required(l10n.getString("required-field")),
            status: yup.boolean(),
        })

        function handleSubmit(values: EditSchedulerJobFormValues) {
            onSubmit(values)
        }

        return (
            <Formik<EditSchedulerJobFormValues>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <EditSchedulerJobFromContent
                        jobInformation={initialValues ? initialValues : defaultInitialValues}
                    />
                </Form>
            </Formik>
        )
    },
)
